<template>
  <div>
    <div class="filter-wrapper" v-if="challenge_type === 'track'">
      <el-select  placeholder="Choose challenge"  v-model="challenge" @change="filterChallenges">
        <span class="separator">Active</span>
        <el-option
          v-for="item in activeChallenges"
          :key="item.id"
          :label="item.track.title"
          :value="item.id"
          @click.native="setBudget(item.budget)"
        >
        </el-option>
        <hr>
        <span class="separator">Expired</span>
        <el-option
            v-for="item in expiredChallenges"
            :key="item.id"
            :label="item.track.title"
            :value="item.id"
            @click.native="setBudget(item.budget)"
        >
        </el-option>
      </el-select>
      <div class="budget">- Available budget - <i class="fas fa-dollar-sign"></i>{{(budget-wallet)/10}}</div>
    </div>
    <div class="filter-wrapper" v-if="challenge_type === 'brand'">
      <el-select placeholder="Choose challenge" v-model="challenge" @change="filterChallenges">
        <span class="separator">Active</span>
        <el-option
          v-for="item in activeChallenges"
          :key="item.id"
          :label="item.brand?item.brand.name:''"
          :value="item.id"
          @click.native="setBudget(item.budget)"
        >
        </el-option>
        <hr>
        <span class="separator">Expired</span>
        <el-option
            v-for="item in expiredChallenges"
            :key="item.id"
            :label="item.brand?item.brand.name:''"
            :value="item.id"
            @click.native="setBudget(item.budget)"
        >
        </el-option>
      </el-select>
      <div class="budget">- Available budget - <i class="fas fa-dollar-sign"></i>{{ (budget - wallet) / 10 }}</div>
    </div>
  </div>

</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  props: {
    challenge_type: {
      type: String
    }
  },
  data() {
    return {
      budget: 0
    }
  },
  computed: {
    ...mapState('youtubeShorts', ['wallet', 'loading', 'music_challenges']),
    challenge: {
      get() {
        return this.$store.getters['youtubeShorts/getChallenges']
      },
      set(value) {
        this.$store.commit('youtubeShorts/setSelectedChallenge', value)
        //this.$store.commit('challenges/setBudget', budget)
      },
    },
    expiredChallenges() {
      const today = new Date();

      return this.music_challenges.filter(item => {
        const endDate = new Date(item.date_end);
        const startDate = new Date(item.date_start);
        return endDate < today && startDate < today;
      });
    },
    activeChallenges() {
      const today = new Date();

      return this.music_challenges.filter(item => {
        const endDate = new Date(item.date_end);
        const startDate = new Date(item.date_start);
        return endDate >= today && startDate < today;
      });
    },
  },

  methods: {
    ...mapActions('youtubeShorts', ['readChallenges', 'read']),
    ...mapMutations('youtubeShorts', [
      'setDialog'
    ]),
    filterChallenges(value) {
      this.read(value)
    },
    setBudget(name) {
      this.budget = name
    },
  },
  created() {
    this.readChallenges(this.challenge_type)
  }
}
</script>

<style lang="scss" scoped>
.filter-wrapper{
  display: flex;
  .budget{
    line-height:40px;
  }
}
.separator {
  padding-left: 12px;
}
</style>
